export default {
  'smbloantemplate.workflow.create': 'Create Loan Template',
  'smbloantemplate.workflow.modify': 'Modify Loan Template',
  'smbloantemplate.workflow.MODIFY_RECURRING': 'Modify Recurring Instructions',
  'smbloantemplate.gridTitle': 'Loan Templates',
  'smbloantemplate.view': 'View Loan Template',
  'smbloantemplate.alert.message': 'You are about to <%= action %> a',
  'smbloantemplate.modifyWarning':
    'All previous payments associated with this instruction "<%- name %>" will be deleted.',
  'smbloantemplate.delete.template': 'Delete Template',
  'smbloantemplate.delete.single.confirmation.line1':
    '1 template will be deleted and permanently removed.',
  'smbloantemplate.delete.multiple.confirmation.line1':
    '<%= count %> templates will be deleted and permanently removed.'
};
